import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { SearchItem } from '@/pages/menu-managements/services/searchItem';
import { Title } from '@/pages/menu-managements/services/title';
import { MenuManagementBrandCategoryService } from '@/services/BrandCategory/MenuManagementBrandCategoryService';

export type ShowBrandCategoryResponse = {
  id: string;
  title: Title;
  memo: string | null;
  brand_item_sort_objects: SearchItem[];
};

export const useMenuManagementBrandCategoryShow = async (
  id: string
): Promise<ShowBrandCategoryResponse> => {
  const menuManagementBrandCategoryService =
    new MenuManagementBrandCategoryService(getClient());
  try {
    const res = await menuManagementBrandCategoryService.show(id);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
